// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"656":"83597455","914":"e2ac73dd"}[chunkId] + ".chunk.css";
};